// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__3oi0u","footerText":"Footer_footerText__AxvF4","footerTextContainer":"Footer_footerTextContainer__uAPJn"};